export type {
  YardAssetDetails,
  AssetContainerStatePresentationInput
} from './yardAssetPresenterShared';

export {
  getAssetContainerStatusIcon,
  getAssetContainerStatusColor,
  getAssetContainerStateIcon
} from './yardAssetPresenterShared';

export { useYardAssetFetcher } from './useYardAssetFetcher';
export type { UseYardAssetFetcherOptions } from './useYardAssetFetcher';
export type { UseYardAssetFetcherOptions as UseYardAssetPresenterOptions } from './useYardAssetFetcher';

export { useYardAssetDisplay } from './useYardAssetDisplay';
export type {
  YardAssetDisplayField,
  YardAssetDisplayData,
  YardAssetDisplayState,
  UseYardAssetDisplayOptions
} from './useYardAssetDisplay';

import { useYardAssetFetcher } from './useYardAssetFetcher';

import type { UseYardAssetFetcherOptions } from './useYardAssetFetcher';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardAssetFetcher}.
 * Pair with {@link useYardAssetDisplay} when fetch is owned by a parent (e.g. list row).
 */
export function useYardAssetPresenter(options: UseYardAssetFetcherOptions) {
  return useYardAssetFetcher(options);
}
